import React from 'react';
import PropTypes from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import GigCardCarouselWrapper from '../shared/GigCardCarouselWrapper';
import SafePureComponent from '../shared/SafePureComponent';
import { RECOMMENDED_FOR_YOU } from '../../utils/carousels';

import './style.scss';

const SimilarGigs = (props, context) => {
    const {
        collections,
        updateCollections,
        isTouch,
        isLoggedIn,
        onEmptyGigs
    } = props;
    const { general, pathfinderWrapper, requestContext } = context;
    const { gigId } = general;
    const { ref } = requestContext.params;

    const url = pathfinderWrapper.pathfinder(
        'gig_page_fetch_recommendations_by_type',
        {type: 'by_content'},
        {query: {gig_id: gigId, ref}}
    );

    return (
        <GigCardCarouselWrapper boxTitle={<I18n k="gig_page_perseus.recommended_gigs.recommended_for_you.title"/>}
            boxClass="gigs-recommended-for-you"
            boxLocation="main"
            carouselPosition={1}
            collections={collections}
            isLoggedIn={isLoggedIn}
            isTouch={isTouch}
            updateCollections={updateCollections}
            type={RECOMMENDED_FOR_YOU}
            url={url}
            onEmptyGigs={onEmptyGigs}
            source="similar_gigs"/>
    );
};

SimilarGigs.propTypes = {
    collections: PropTypes.object,
    updateCollections: PropTypes.func,
    isTouch: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    onEmptyGigs: PropTypes.func
};

SimilarGigs.contextTypes = {
    general: PropTypes.object,
    pathfinderWrapper: PropTypes.object,
    requestContext: PropTypes.object
};

export { SimilarGigs };
export default SafePureComponent(SimilarGigs);
